<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row class="top">
          <el-col :span="2">汇流箱对比分析</el-col>
          <el-col :span="3"><el-button icon="el-icon-circle-plus-outline" size="small"
              @click="Popup">指定已清洗汇流箱</el-button></el-col>
          <el-col :span="4"><el-button icon="el-icon-circle-plus-outline" size="small"
              @click="Popup">指定未清洗汇流箱</el-button></el-col>
        </el-row>
        <el-row class="top" style="padding:0 20px;">
          <el-table :data="tableData" border :header-cell-style="{background: 'rgb(241, 244, 247)'}"
            style="width: 100%">
            <el-table-column type="index" align="center" width="50">
            </el-table-column>
            <el-table-column prop="name" label="汇流箱名称" align="center" width="300">
            </el-table-column>
            <el-table-column prop="cleaning" label="是否已清洗" align="center" width="150">
            </el-table-column>
            <el-table-column prop="currentGeneration" label="今日发电量" align="center" width="300">
            </el-table-column>
            <el-table-column prop="yesterdayGeneration" label="昨日发电量" align="center" width="300">
            </el-table-column>
            <el-table-column prop="amount" label="支路数量" align="center" width="150">
            </el-table-column>
            <el-table-column prop="todaysBranch" label="今日支路平均发电量" align="center" width="300">
            </el-table-column>
            <el-table-column prop="yesterdayBranch" align="center" label="昨日支路平均发电量">
            </el-table-column>
          </el-table>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="top">
      <el-col>全站信息分析</el-col>
      <el-row>
        <el-table :data="blogData" border :header-cell-style="{background: 'rgb(241, 244, 247)'}" style="width: 100%">
          <el-table-column type="index" align="center" width="50">
          </el-table-column>
          <el-table-column prop="cleaning" label="是否需要清洁" align="center" width="300">
          </el-table-column>
          <el-table-column prop="amount" label="全站总支路数量" align="center" width="180">
          </el-table-column>
          <el-table-column prop="electricity" label="电费单价(元/kW·h)" align="center" width="360">
          </el-table-column>
          <el-table-column prop="balance" label="清洁/不清洁总电费差额(元)" align="center" width="360">
          </el-table-column>
          <el-table-column prop="cost" label="总清洁费用(元)" align="center" width="360">
          </el-table-column>
          <el-table-column prop="deviation" align="center" label="允许偏差量(元)">
          </el-table-column>
        </el-table>
      </el-row>
    </el-row>
    </el-col>
    </el-row>
    <el-dialog title="请指定已清理汇流箱" :visible.sync="dialogVisible" width="30%">
      <el-row>
        <el-col class="border">
          <el-col>
            <el-checkbox-group v-model="checkList" style="display: grid;">
              <el-checkbox v-for="item in checkData" :key="item.name" :label="item.name"
                style="margin-bottom: 10px;"></el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dialogVisible: false,
        checkList: [],
        checkData: [],
        tableData: [{
          name: '请指定未清洗汇流箱',
          cleaning: '',
          currentGeneration: '--',
          yesterdayGeneration: '--',
          amount: '0',
          todaysBranch: '--',
          yesterdayBranch: '--'
        },{
          name: '请指定已清洗汇流箱',
          cleaning: '',
          currentGeneration: '--',
          yesterdayGeneration: '--',
          amount: '0',
          todaysBranch: '--',
          yesterdayBranch: '--'
        }],
        blogData: [{
          cleaning: '--',
          amount: '9000',
          electricity: '0.87',
          balance: '--',
          cost: '14441',
          deviation: '-1000'
        }]
      }
    },
    mounted () {
      for(let i=0;i<100;i++) {
        this.checkData.push({name: 'E-01-A-2汇流箱'+i})
      }
    },
    methods: {
      Popup () {
        this.dialogVisible=true
      }
    }
  }
</script>

<style scoped>
  .top {
    padding: 20px;
    line-height: 27px;
  }

  .el-button--small {
    padding: 6.5px 36px;
  }

  .el-col {
    margin: 0 0 15px 0;
  }

  /deep/ .el-table,
  .el-table__expanded-cell {
    background-color: 'rgb(255, 255, 255)';
    background-color: transparent;
  }

  .border {
    background: #fff;
    border: 1px solid silver;
    border-radius: 5px;
    overflow-y: auto;
    height: 360px;
    padding: 10px;
  }

  /* 隐藏滚动条 */
  .border::-webkit-scrollbar {
    display: none;
  }
</style>